import { Reducer } from "redux";

import { DownloadDocumentOfNotificationResponse } from "../models/api/Referral";
import { DownloadDocumentOfNotificationActionDispatchTypes } from "../constants/Referral";
import { DownloadDocumentOfNotificationDispatchTypes } from "../models/dispatchTypes/Referral";

const initialState: DownloadDocumentOfNotificationResponse = {
  loading: false,
  response: null,
  error: null,
  progress: 0,
};

const DownloadDocumentOfNotificationReducer: Reducer<
  DownloadDocumentOfNotificationResponse,
  DownloadDocumentOfNotificationDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case DownloadDocumentOfNotificationActionDispatchTypes.DOWNLOAD_DOCUMENT_OF_NOTIFICATION_INVOKE: {
      return {
        ...state,
        response: null,
        loading: true,
        error: null,
      };
    }
    case DownloadDocumentOfNotificationActionDispatchTypes.DOWNLOAD_DOCUMENT_OF_NOTIFICATION_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
        error: null,
      };
    }
    case DownloadDocumentOfNotificationActionDispatchTypes.DOWNLOAD_DOCUMENT_OF_NOTIFICATION_ERROR: {
      return {
        ...state,
        error: action.response,
        response: null,
        loading: false,
      };
    }
    case DownloadDocumentOfNotificationActionDispatchTypes.DOWNLOAD_DOCUMENT_OF_NOTIFICATION_PROGRESS: {
      return {
        ...state,
        loading: true,
        error: null,
        progress: action.progress,
      };
    }

    case DownloadDocumentOfNotificationActionDispatchTypes.DOWNLOAD_DOCUMENT_OF_NOTIFICATION_RESET: {
      return initialState;
    }
  }
  return state;
};

export default DownloadDocumentOfNotificationReducer;